export default "__VITE_ASSET__A$UdUIpC__"